import { formatNumber } from '../helpers'

export function formatMoney(amount, { signed = false } = {}) {
  const n = Math.round(Number(amount) || 0)
  const formatted = `$${formatNumber(Math.abs(n))}`

  if (!signed) return formatted
  if (n > 0) return `+${formatted}`
  if (n < 0) return `-${formatted}`
  return formatted
}

export function formatConfidence(score) {
  const n = Math.round(Number(score) || 0)
  return `${Math.min(100, Math.max(0, n))}%`
}
